export const historyIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.625 14C4.625 15.8542 5.17483 17.6668 6.20497 19.2085C7.23511 20.7502 8.69929 21.9518 10.4123 22.6614C12.1254 23.3709 14.0104 23.5566 15.829 23.1949C17.6475 22.8331 19.318 21.9402 20.6291 20.6291C21.9402 19.318 22.8331 17.6475 23.1949 15.829C23.5566 14.0104 23.3709 12.1254 22.6614 10.4123C21.9518 8.69929 20.7502 7.23511 19.2085 6.20497C17.6668 5.17483 15.8542 4.625 14 4.625C11.3791 4.63486 8.86351 5.65752 6.97917 7.47917L4.625 9.83333"
      stroke="#4A5565"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.625 4.625V9.83333H9.83333"
      stroke="#4A5565"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 8.79167V14L18.1667 16.0833"
      stroke="#4A5565"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
